export default {
  header: {
    home: '首頁',
    categories: '分類',
    about: '關於',
    searchPlaceholder: '搜尋遊戲...',
    toggleDarkMode: '切換深色模式',
    toggleLightMode: '切換淺色模式',
    changeLanguage: '切換語言'
  },
  nav: {
    home: '首頁',
    categories: '分類',
    popular: '熱門',
    favorites: '收藏',
    search: '搜尋...',
    login: '登入',
    register: '註冊',
    myProfile: '我的資料',
    settings: '設定',
    logout: '登出',
    darkMode: '深色模式',
    lightMode: '淺色模式',
    language: '語言',
    about: '關於'
  },
  footer: {
    about: '關於我們',
    contact: '聯絡我們',
    contactUs: '聯絡我們',
    policy: '私隱政策',
    terms: '使用條款',
    copyright: '© {year} GoGameVault. 版權所有。',
    playOnline: '網上遊戲',
    bestGames: '最佳遊戲',
    newGames: '新遊戲',
    popularGames: '熱門遊戲',
    followUs: '關注我們',
    disclaimer: '所有遊戲均屬於原作者，本網站不聲稱擁有任何相關權利。',
    introText: '最佳免費網上遊戲平台。無需下載，無需註冊，純粹樂趣！',
    quickLinks: '快速連結',
    popularCategories: '熱門分類',
    contactText: '有問題、建議或意見？我們很樂意聽取您的意見！',
    aboutUs: '關於我們'
  },
  gameCard: {
    play: '立即遊玩',
    new: '新遊戲',
    popular: '熱門'
  },
  shareButtons: {
    share: '分享',
    copyLink: '複製連結',
    facebook: '分享到Facebook',
    twitter: '分享到Twitter',
    whatsapp: '分享到WhatsApp',
    telegram: '分享到Telegram',
    copied: '已複製！'
  },
  searchBar: {
    search: '搜尋',
    placeholder: '尋找您喜歡的遊戲...'
  },
  share: {
    title: '分享',
    copy: '複製連結',
    copied: '已複製',
    instagramNotSupported: 'Instagram暫不支援直接分享連結'
  }
}; 